<template>
  <b-modal title="Edição de Trabalho" v-model="show" size="xl">
    <!-- :::::::::::::::::::::::::::: FORMULARIO DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <b-container fluid class="p-0 m-0">
      <b-row class="m-2">
        <b-col cols="6">
          <b-form-group label="Sgcq:" label-for="sgcq" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="sgcq" v-model="trabalho.sgcq" disabled />
          </b-form-group>
          <b-form-group label="Nome:" label-for="nome" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="nome" v-model="trabalho.nome" />
          </b-form-group>
          <b-form-group label="Código:" label-for="codigo" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="codigo" v-model="trabalho.codigo" />
          </b-form-group>
          <b-form-group label="Fabricante:" label-for="fab" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="fab" v-model="trabalho.fabricante" />
          </b-form-group>
          <b-form-group label="Dimensões:" label-for="dimensoes" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="dimensoes" v-model="trabalho.dimensoes" />
          </b-form-group>
          <b-form-group label="Peso:" label-for="peso" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="peso" v-model="trabalho.peso" />
          </b-form-group>
          <b-form-group label="Carga:" label-for="carga" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="carga" v-model="trabalho.carga" />
          </b-form-group>
          <b-form-group label-cols-sm="2" label="Obs.:" label-align-sm="right">
            <b-form-textarea v-model="trabalho.observacao" rows="2"></b-form-textarea>
          </b-form-group>
          <b-form-group label-cols-sm="2" label="Serviço:" label-align-sm="right">
            <b-form-textarea v-model="trabalho.servico" rows="2"></b-form-textarea>
          </b-form-group>
        </b-col>

        <!-- :::::::::::::::::::::::::::: EQUIPAMENTO :::::::::::::::::::::::::::: -->
        <b-col cols="6">
          <b-form-group label="Sgcq:" label-for="esgcq" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="esgcq" v-model="equipamento.sgcq" disabled />
          </b-form-group>
          <b-form-group label="Nome:" label-for="enome" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="enome" v-model="equipamento.nome" disabled />
          </b-form-group>
          <b-form-group label="Código:" label-for="ecodigo" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="ecodigo" v-model="equipamento.codigo" disabled />
          </b-form-group>
          <b-form-group label="Fabricante:" label-for="efab" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="efab" v-model="equipamento.fabricante" disabled />
          </b-form-group>
          <b-form-group label="Dimensões:" label-for="edimensoes" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="edimensoes" v-model="equipamento.dimensoes" disabled />
          </b-form-group>
          <b-form-group label="Peso:" label-for="epeso" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="epeso" v-model="equipamento.peso" disabled />
          </b-form-group>
          <b-form-group label="Carga:" label-for="ecarga" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="ecarga" v-model="equipamento.carga" disabled />
          </b-form-group>
          <b-form-group label-cols-sm="2" label="Obs.:" label-align-sm="right">
            <b-form-textarea v-model="equipamento.observacao" rows="2" disabled />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <confirm-modal ref="confirmTrabalho" :descricao="'Deseja realmente excluir o trabalho ?'" @executar="executar()" />

    <template #modal-footer>
      <b-input-group class="clone-input">
        <b-input-group-prepend is-text>
          <b-icon icon="search" @click="clonar()"></b-icon>
        </b-input-group-prepend>
        <b-form-input type="number" placeholder="Clonar Sgcq" v-model="clone" />
      </b-input-group>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="danger" @click="deletar()">Deletar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Atividade from "@/models/Avulso";
import Trabalho from "@/models/Trabalho";
import Equipamento from "@/models/Equipamento";
import Notificacao from "@/models/Notificacao";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "TrabalhoListModal",

  data() {
    return {
      show: false,
      atividade: new Atividade(0, "Nova Atividade", "", new Date(), "", ""),
      trabalho: new Trabalho(0, "", "", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "", "", "", "", "", "", "", "", "", "", ""),
      clone: "",
    };
  },

  components: {
    "confirm-modal": ConfirmModal,
  },

  methods: {
    salvar() {
      if (this.trabalho.id != 0) {
        this.atividadeStore.ALTERAR_TRABALHO(this.trabalho).then(() => {
          this.store.NOTIFICAR(new Notificacao("Trabalho salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      } else {
        this.atividadeStore.CADASTRAR_TRABALHO(this.trabalho).then(() => {
          this.store.NOTIFICAR(new Notificacao("Trabalho salvo no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      }
      this.show = !this.show;
    },

    deletar() {
      this.$refs.confirmTrabalho.call();
    },

    executar() {
      this.atividadeStore.REMOVER_TRABALHO(this.trabalho.id).then(() => {
        this.store.NOTIFICAR(new Notificacao("Trabalho removido do SGCQ com sucesso!", "Permanente!", "danger"));
        this.$emit("update");
        this.show = !this.show;
      });
    },

    clonar() {
      let clonado = this.getBySgcq(this.clone);
      if (clonado[0]) {
        this.trabalho.nome = clonado[0].nome;
        this.trabalho.codigo = clonado[0].codigo;
        this.trabalho.fabricante = clonado[0].fabricante;
        this.trabalho.dimensoes = clonado[0].dimensoes;
        this.trabalho.peso = clonado[0].peso;
        this.trabalho.carga = clonado[0].carga;
        this.trabalho.observacao = clonado[0].observacao;
        this.trabalho.grupo = clonado[0].grupo;
        this.trabalho.referencia = clonado[0].referencia;
      }
      this.equipamento.update(clonado[0]);
    },

    call(trabalho) {
      this.show = !this.show;
      this.trabalho = trabalho;
      if (trabalho.id != 0) {
        let eqp = this.getBySgcq(trabalho.sgcq);
        this.equipamento.update(eqp[0]);
      }
    },
  },

  setup() {
    const store = useSgcqStore();
    const atividadeStore = useAtividadeStore();
    const { getTrabalhos } = storeToRefs(atividadeStore);
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);

    return {
      store,
      atividadeStore,
      getTrabalhos,
      equipamentoStore,
      getBySgcq,
    };
  },
};
</script>

<style lang="scss" scoped>
.clone-input {
  width: 12rem;
}
</style>
